import { render, staticRenderFns } from "./TemaVistaPrevia.vue?vue&type=template&id=197fe388&scoped=true&"
import script from "./TemaVistaPrevia.vue?vue&type=script&lang=js&"
export * from "./TemaVistaPrevia.vue?vue&type=script&lang=js&"
import style0 from "./TemaVistaPrevia.vue?vue&type=style&index=0&id=197fe388&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197fe388",
  null
  
)

export default component.exports